import { toDateIST } from '../../utils/date';

export function buildDateStrip(start) {
  return Array.from({ length: 14 }, (_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    const iso = toDateIST(d);
    return {
      iso,
      day: Number(iso.slice(-2)),
      weekday: d.toLocaleDateString('en-IN', { weekday: 'short', timeZone: 'Asia/Kolkata' }),
      month: d.toLocaleDateString('en-IN', { month: 'short', timeZone: 'Asia/Kolkata' }),
    };
  });
}

/** Index public doctor cards by id and name for booking enrichment. */
export function indexDoctorProfiles(doctorProfiles = []) {
  const map = {};
  doctorProfiles.forEach((d) => {
    const id = d.doctor_id || d.id;
    if (id) map[id] = d;
    if (d.name) map[`name:${d.name}`] = d;
  });
  return map;
}
